import React from "react";
import { Link } from "react-router-dom";
import {
    FaHome,
    FaBuilding,
    FaBriefcase,
    FaThList,
    FaUserShield,
    FaExternalLinkAlt
} from "react-icons/fa";
import "./LegalPages.css";

const Sitemap = () => {
    // Navbar dynamic & structural representation
    const siteStructure = [
        {
            title: "Main Navigation",
            icon: <FaHome />,
            links: [
                { name: "Home", path: "/", external: false },
                { name: "Gallery", path: "/gallery", external: false },
                { name: "Blogs", path: "/blogs", external: false },
                { name: "FAQ", path: "/faq", external: false },
                { name: "Contact Us", path: "/contact-us", external: false },
            ],
        },
        {
            title: "About Us",
            icon: <FaBuilding />,
            links: [
                { name: "About Us Overview", path: "/about-us", external: false },
                { name: "Our Story", path: "/about-us/our-story", external: false },
                { name: "Mission & Vision", path: "/about-us/mission-vision", external: false },
                { name: "Our Core Values", path: "/about-us/our-core-values", external: false },
                { name: "Executive Committee", path: "/about-us/executive-committee", external: false },
                { name: "Board Of Directors", path: "/about-us/board-of-directors", external: false },
                { name: "Why Choose Us", path: "/about-us/why-choose-us", external: false },
                { name: "Testimonials", path: "/about-us/testimonials", external: false },
            ],
        },
        {
            title: "Our Sister Concerns",
            icon: <FaBriefcase />,
            links: [
                { name: "Iconic Express", path: "https://iconicexpressbd.com/", external: true },
                { name: "Iconic Greenland", path: "https://www.iconicgreenland.com/", external: true },
                { name: "Iconic Digital Solutions", path: "https://iconicdigitalsolution.com/", external: true },
                { name: "Iconic Soft Ltd", path: "https://iconicsoftltd.com/", external: true },
                { name: "BD Iconic KSA", path: "https://www.bdiconicksa.com/", external: true },
                { name: "Iconic Furniture Ltd", path: "https://iconicfurniturebd.com/", external: true },
                { name: "Iconic Global Travels Ltd", path: "https://iconictravelsbd.com/", external: true },
                { name: "Iconic Motors", path: "https://iconicmotorsltd.com", external: true },
                { name: "Iconic Tracker", path: "https://iconictracker.com/", external: true },
                { name: "Iconic Transport", path: "#", external: true },
                { name: "Iconic Holidays", path: "#", external: true },
                { name: "Iconic Shikhon", path: "https://iconicshikhon.com", external: true },
            ],
        },
        {
            title: "Account & Portal Access",
            icon: <FaThList />,
            links: [
                { name: "Login", path: "/login", external: false },
                { name: "Register", path: "/register", external: false },

            ],
        },
        {
            title: "Legal & Policies",
            icon: <FaUserShield />,
            links: [
                { name: "Privacy Policy", path: "/privacy", external: false },
                { name: "Terms & Conditions", path: "/terms-and-conditions", external: false },

            ],
        },
    ];

    return (
        <div className="legal-page-container">
            {/* 1. Header Banner */}
            <section className="legal-hero-banner">
                <h1 className="legal-hero-title">SITEMAP</h1>
                <p className="legal-hero-effective-date">
                    Complete Directory & Structure of Iconic Unity Group Portal
                </p>
            </section>

            {/* 2. Main Body Content */}
            <div className="legal-content-wrapper">
                <div className="legal-container-max">
                    <p
                        className="legal-paragraph"
                        style={{ textAlign: "center", marginBottom: "40px", fontSize: "1.05rem" }}
                    >
                        Looking for something specific? Use this complete directory to easily navigate through all internal pages, sister concerns, corporate profiles, and member settings across our web platform.
                    </p>

                    {/* Grid Layout */}
                    <div className="sitemap-grid">
                        {siteStructure.map((section, idx) => (
                            <div key={idx} className="sitemap-card">
                                <div className="sitemap-card-header">
                                    <span className="sitemap-icon">{section.icon}</span>
                                    <h3 className="sitemap-card-title">{section.title}</h3>
                                </div>

                                <ul className="sitemap-list">
                                    {section.links.map((link, lIdx) => (
                                        <li key={lIdx}>
                                            {link.external ? (
                                                <a
                                                    href={link.path}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="sitemap-link external-link"
                                                >
                                                    {link.name} <FaExternalLinkAlt className="ext-icon" />
                                                </a>
                                            ) : (
                                                <Link to={link.path} className="sitemap-link">
                                                    {link.name}
                                                </Link>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>

                    <hr className="legal-divider" style={{ marginTop: "50px" }} />

                    {/* Contact Section */}
                    <div className="legal-contact-section">
                        <h3 className="legal-section-title">Corporate Head Office</h3>
                        <div className="legal-contact-details">
                            <strong>Iconic Unity Group</strong><br />
                            <strong>Address:</strong> Suite: 8/A&B, LilyPond Center, 3, R. K. Mission Road, Motijheel, Dhaka-1000, Bangladesh<br />

                            <strong>Email:</strong> <span id='info-color'>info@iconicunitygroup.com</span><br />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sitemap;